import { render, staticRenderFns } from "./CreatePagos.vue?vue&type=template&id=76d64b1b&"
import script from "./CreatePagos.vue?vue&type=script&lang=js&"
export * from "./CreatePagos.vue?vue&type=script&lang=js&"
import style0 from "./CreatePagos.vue?vue&type=style&index=0&id=76d64b1b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports